import React from 'react';
import hive from '@bombas/hive';
import LinkText from '../LinkText/LinkText';
import * as Styled from './MessageTier.styled';
/** Component that renders different UI based on the number of available tiered discounts */
var MessageTier = function (_a) {
    var savings = _a.savings, _b = _a.size, size = _b === void 0 ? undefined : _b, setQBSModalOpen = _a.setQBSModalOpen;
    return (React.createElement(Styled.MessageTier, null, savings.length === 1 ? (React.createElement(Styled.SingleTier, null,
        React.createElement(LinkText, { size: size, onClick: function () {
                // checking for window adds support for SSR, where window is undefined on the server and causes errors in rendering
                if (typeof window !== 'undefined') {
                    hive.track('QBS_MODAL_OPEN');
                }
                setQBSModalOpen(true);
            } },
            "Build a Pack & Save ",
            savings[0].discount,
            "% on ",
            savings[0].quantity,
            "+"))) : (React.createElement(React.Fragment, null,
        React.createElement(Styled.Divider, null),
        React.createElement(Styled.MultiTier, null,
            React.createElement(Styled.LeftContent, null,
                React.createElement("section", null,
                    React.createElement(Styled.Subtitle, null,
                        "Buy More ",
                        savings[0].displayName,
                        ", Save More"),
                    React.createElement(Styled.DetailsContainer, null,
                        React.createElement(LinkText, { size: "Mini", underline: true, onClick: function () { return setQBSModalOpen(true); } }, "Details")))),
            React.createElement(Styled.RightContent, null,
                React.createElement("section", null, savings.map(function (discountTier, idx) { return (React.createElement(Styled.Text, { key: idx },
                    "Build a Pack & Save ",
                    discountTier.discount,
                    "% on",
                    ' ',
                    discountTier.quantity,
                    "+")); }))))))));
};
export default MessageTier;
